export const handleEbayIntegrate = async (e) => {
  e.stopPropagation();
  try {
    const res = await fetch(
      "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/ebayUrlFB",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    const data = await res.json();
    if (data?.url) {
      window.location.href = data.url;
    } else {
      console.error("eBay auth URL not received");
    }
  } catch (err) {
    console.error("eBay integrate error:", err);
  }
};

export const buildEbayAspects = (categoryAspects = []) => {
  const aspects = {};
  categoryAspects.forEach((a) => {
    aspects[a.localizedAspectName] =
      a.value && a.value.trim() !== "" ? [a.value] : ["N/A"];
  });
  return aspects;
};

export const buildMetafieldsFromAnalysis = (activeMetafields, responseData) => {
  const result = {};

  const analysis = responseData?.analysis || {};
  const aiMetafields = analysis.metafields || {};
  const productMeta = responseData?.product_metadata || {};

  activeMetafields.forEach((mf) => {
    const key = mf.key;

    if (aiMetafields.hasOwnProperty(key)) {
      result[key] = aiMetafields[key] || "";
    } else if (analysis.hasOwnProperty(key)) {
      result[key] = analysis[key] || "";
    } else if (productMeta.hasOwnProperty(key)) {
      result[key] = productMeta[key] || "";
    } else {
      result[key] = "";
    }
    console.log("result[key]", result[key]);
  });

  return result;
};

export const getVintedCategoryIcon = (categoryName) => {
  const lower = categoryName.toLowerCase();
  if (lower.includes("woman") || lower.includes("women")) return "👩";
  if (lower.includes("man") || lower.includes("men")) return "👨";
  if (lower.includes("kid") || lower.includes("child")) return "👶";
  if (lower.includes("home")) return "🏠";
  if (lower.includes("electronic")) return "📱";
  if (lower.includes("sport")) return "⚽";
  if (
    lower.includes("cloth") ||
    lower.includes("dress") ||
    lower.includes("shirt")
  )
    return "👕";
  if (lower.includes("shoe")) return "👟";
  if (lower.includes("bag")) return "👜";
  if (lower.includes("accessory")) return "⌚";
  if (lower.includes("toy")) return "🧸";
  if (lower.includes("book")) return "📚";
  if (lower.includes("beauty") || lower.includes("makeup")) return "💄";
  return "📁";
};

